import { create } from "zustand";
import type { DashboardEvent } from "@ajnt/shared";

type ConnectionStatus = "connected" | "connecting" | "disconnected";

const MAX_EVENTS = 200;

interface DashboardState {
  realtimeEvents: DashboardEvent[];
  connectionStatus: ConnectionStatus;
  sidebarCollapsed: boolean;
}

interface DashboardActions {
  addEvent(event: DashboardEvent): void;
  clearEvents(): void;
  setConnectionStatus(status: ConnectionStatus): void;
  toggleSidebar(): void;
}

export const useDashboardStore = create<DashboardState & DashboardActions>(
  (set) => ({
    realtimeEvents: [],
    connectionStatus: "disconnected",
    sidebarCollapsed: false,

    addEvent(event: DashboardEvent) {
      set((state) => {
        const updated = [...state.realtimeEvents, event];
        // Ring buffer: keep only the last MAX_EVENTS
        if (updated.length > MAX_EVENTS) {
          return { realtimeEvents: updated.slice(updated.length - MAX_EVENTS) };
        }
        return { realtimeEvents: updated };
      });
    },

    clearEvents() {
      set({ realtimeEvents: [] });
    },

    setConnectionStatus(status: ConnectionStatus) {
      set({ connectionStatus: status });
    },

    toggleSidebar() {
      set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
    },
  }),
);
